import { Info } from 'lucide-react';

/**
 * MANDATORY disclaimer component for equipment analytics
 * Must be included on every view showing job_attributed metrics
 */
export function AttributionDisclaimer() {
  return (
    <div className="bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800 rounded-lg p-4 text-sm">
      <div className="flex items-start gap-2">
        <Info className="h-4 w-4 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-medium text-blue-900 dark:text-blue-100">About these numbers</p>
          <p className="text-blue-700 dark:text-blue-300 mt-1">
            Equipment metrics show labor enabled by this asset, not revenue. 
            Multiple assets may enable the same labor hours. Shop totals are 
            calculated separately to avoid double counting.
          </p>
        </div>
      </div>
    </div>
  );
}
